export const services = [
  {
    id: 1,
    serviceName: "Automotive Tint",
    description:
      "Window Tint can improve the in-car experience by enhancing privacy, reducing infra-red heat, cutting glare, as well as keeping your skin & eyes safe from harmful UV rays. From nearly optically clear to the blacked out “limo” look, we’ve got the perfect  window tint for every automobile.",
    img: "/images/services-images/tinting.jpg",
    products: ["xpel"],
    link: "/services/automotivetint",
    simulator: "/simulator",
    shades: [5, 20, 35, 50],
    prices: {
      sedan: 280,
      truck: 220,
      minivan: 350,
    },
  },

  {
    id: 2,
    serviceName: "Paint Protection Film",
    description:
      "Often referred to as “PPF,” Self-Healing Paint Protection Film is perfect for protecting high impact areas, or even doing full coverage car wraps . Keep your paint safe from chips, scratches, and road debris with glossy or satin or hydrophobic finish today.",
    img: "/images/services-images/ppf.jpg",
    products: ["xpel", "vps"],
    link: "/services/paintprotectionfilm",
    simulator: "/simulator",
    prices: {
      bronze: 399,
      silver: 899,
      gold: 1099,
    },
  },
  {
    id: 3,
    serviceName: "Home & Office Tint",
    description:
      "In this day & age, the home is more than just a place to rest your head. Personal residences have grown to be multi-purpose, becoming work spaces, small businesses, schools, and gyms in more ways than one – and it can have an impact. Using the latest window films, antimicrobial film, and surface protection products, window tint can help maintain the quality of living at any residence both inside and out.",
    img: "/images/services-images/officetint.jpg",
    products: ["xpel"],
    link: "/services/home-office",
    simulator: "/calculator",
    shades: [5, 20, 35, 50],
    prices: {
      sedan: 280,
      truck: 220,
      minivan: 350,
    },
  },
  // {
  //   id: 4,
  //   serviceName: "Advertising Wraps",
  //   img: "/images/services-images/wraps.jpg",
  //   products: ["3m", "avery"],
  //   link: "/services/advertisingwraps",
  //   simulator: "/wrap-calculator",
  //   prices: {
  //     from: 1999,
  //   },
  // },
  // {
  //   id: 5,
  //   serviceName: "Powersports",
  //   img: "/images/services-images/powersports.jpg",
  //   products: ["3m", "avery"],
  //   link: "/services/powersports",
  //   simulator: "/simulator-powersports",
  //   prices: {
  //     from: 1999,
  //   },
  // },
];
